import { Type } from '@sinclair/typebox';
import { getAdditionalHeaders } from "./actions.mjs";
import { getWithRetries } from "./http.mjs";
import { countriesResponseSchema } from "./shipping.mjs";
import { createMemoizedFunction, withLocalStorageCache } from "./utils.mjs";
export const meta = Type.Record(Type.String(), Type.Union([Type.String(), Type.Number(), Type.Null()]));
export const parts = Type.Unknown();
export const getCountries = (state) => {
    return createMemoizedFunction(() => {
        const cacheKey = 'checkout-countries-cache';
        const cacheExpiryMs = 60 * 60 * 1000; // 60 minutes in milliseconds
        return withLocalStorageCache(cacheKey, cacheExpiryMs, () => {
            return getWithRetries('/shipping/countries', state.checkoutApiBaseUrl, countriesResponseSchema, state.token, getAdditionalHeaders(state));
        });
    });
};
//# sourceMappingURL=atlas.js.map